/**
 * @generated SignedSource<<f58230ff732984390e3fa10aa286f7b4>>
 * @relayHash 1b9c8f622ddd75c98ac58c53ee16a43b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6c1ad3ba282a42d687c2198e1c032ca40688427aa7280fcc2cd1cb87f1e323e0

import type { ConcreteRequest, Query } from 'relay-runtime';
export type GlobalSpaceQuery$variables = {
  cloudId: string;
};
export type GlobalSpaceQuery$data = {
  readonly confluence_questionsConfiguration: {
    readonly confluenceQuestionsGlobalSpaceId: string | null | undefined;
    readonly confluenceQuestionsGlobalSpaceKey: string | null | undefined;
    readonly hasConfluenceQuestionsAccess: boolean | null | undefined;
  } | null | undefined;
};
export type GlobalSpaceQuery = {
  response: GlobalSpaceQuery$data;
  variables: GlobalSpaceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "ConfluenceQuestionsConfiguration",
    "kind": "LinkedField",
    "name": "confluence_questionsConfiguration",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "confluenceQuestionsGlobalSpaceKey"
      },
      {
        "kind": "ScalarField",
        "name": "hasConfluenceQuestionsAccess"
      },
      {
        "kind": "ScalarField",
        "name": "confluenceQuestionsGlobalSpaceId"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GlobalSpaceQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GlobalSpaceQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1b9c8f622ddd75c98ac58c53ee16a43b",
    "id": "6c1ad3ba282a42d687c2198e1c032ca40688427aa7280fcc2cd1cb87f1e323e0",
    "metadata": {},
    "name": "GlobalSpaceQuery",
    "operationKind": "query",
    "text": "query GlobalSpaceQuery($cloudId:ID!){confluence_questionsConfiguration(cloudId:$cloudId){confluenceQuestionsGlobalSpaceKey,hasConfluenceQuestionsAccess,confluenceQuestionsGlobalSpaceId}}"
  }
};
})();

(node as any).hash = "03955db9b4960772eed9546a1ebbec30";

export default node;
